(function ($) {
  $(document).ready(function ($) {
    /**********************************************************************
    Table of Contents:
      1. Opening and closing of the cart globally
      2. Updates price when a variant is changed within product pages
      3. Handling of the quantity box clicks & changes
      4: Updating cart state when user clicks cart-plus or cart-minus
      5: Update the shipping message and shipping 'load bar'
      6. Adding to Cart
      7. Removing from Cart
      8. Re-generating the AJAX cart items when cart is changed
      9. Custom event for handling error messages that arise from cart events
      10. Shopify function for handling money formatting
    ***********************************************************************/

    /**********************************************************************
     1.
      Opening & closing the cart
    ***********************************************************************/
    function openCart() {
      $("body").addClass("cart-open noscroll");
      $("body").removeClass("scrolling-down");
      $("#cart-popper").attr("aria-expanded", "true");
      $("#cart-pop").attr({ "aria-hidden": "false", tabindex: "-1" });
      $("#cart-pop").focus();
    }

    function closeCart() {
      $("body").removeClass("cart-open noscroll");
      $("#cart-popper").attr("aria-expanded", "false");
      $("#cart-pop").attr({ "aria-hidden": "true", tabindex: "" });
      $("#Main-Content").focus();
    }

    $("#cart-popper").click(function (event) {
      openCart();
    });

    $("#close-cart-popper").click(function (event) {
      closeCart();
    });
    /**********************************************************************
      END –
      Opening & closing the cart
    ***********************************************************************/

    /**********************************************************************
     2. 
      If the select for the product changes, update the price on the page
    ***********************************************************************/
    $(".product-select").on("change", function () {
      $(".product-page-price").html($(this).find(":selected").data("price"));
    });

    /**********************************************************************
     2b. 
      Recharge Subscription Widget - Update price when subscription option changes
      Note: Recharge widget uses Shadow DOM (open), so we query prices directly
      from the shadow root and use the widget's purchaseOption property.
    ***********************************************************************/
    var RechargeWidgetHandler = (function () {
      var $priceElement = $(".product-page-price.product-price");

      // Get prices from Recharge widget's shadow DOM
      function getPricesFromWidget() {
        var widget = document.querySelector("recharge-subscription-widget");
        if (!widget || !widget.shadowRoot) return null;

        var purchaseOption = widget.purchaseOption;
        var result = {
          purchaseOption: purchaseOption,
          originalPrice: null,
          discountedPrice: null,
        };

        // Get one-time/original price
        var onetimeEl = widget.shadowRoot.querySelector(".rc-purchase-option__price, [part='rc-purchase-option__price']");
        if (onetimeEl) {
          var onetimeText = onetimeEl.textContent.trim();
          var onetimeMatch = onetimeText.match(/\$[\d,.]+/);
          if (onetimeMatch) {
            result.originalPrice = onetimeMatch[0];
          }
        }

        // Get discounted subscription price
        var discountedEl = widget.shadowRoot.querySelector(
          ".rc-purchase-option__discounted-price, [part='rc-purchase-option__discounted-price']"
        );
        if (discountedEl) {
          var discountedText = discountedEl.textContent.trim();
          var discountedMatch = discountedText.match(/\$[\d,.]+/);
          if (discountedMatch) {
            result.discountedPrice = discountedMatch[0];
          }
        }

        return result;
      }

      // Update the displayed price with optional strikethrough
      function updatePriceDisplay() {
        var prices = getPricesFromWidget();
        if (!prices) return;

        if (prices.purchaseOption === "subscription" && prices.discountedPrice) {
          // Show strikethrough original price + discounted price
          $priceElement.html(
            '<span class="price-original">' +
              prices.originalPrice +
              "</span>" +
              '<span class="price-discounted">' +
              prices.discountedPrice +
              "</span>"
          );
          $priceElement.addClass("has-discount");
        } else if (prices.originalPrice) {
          // Show regular price
          $priceElement.text(prices.originalPrice);
          $priceElement.removeClass("has-discount");
        }
      }

      // Listen for clicks on the widget
      $(document).on("click", "recharge-subscription-widget", function () {
        // Small delay to allow Recharge to update its internal state
        setTimeout(updatePriceDisplay, 150);
      });

      // MutationObserver to detect changes in the shadow DOM
      function observeWidget() {
        var widget = document.querySelector("recharge-subscription-widget");
        if (!widget) {
          // Widget not yet in DOM, try again
          setTimeout(observeWidget, 500);
          return;
        }

        // Observe the widget element for attribute changes
        var widgetObserver = new MutationObserver(function () {
          setTimeout(updatePriceDisplay, 50);
        });

        widgetObserver.observe(widget, {
          attributes: true,
          attributeFilter: ["purchase-option", "selling-plan-id"],
        });

        // Also observe the shadow root for DOM changes
        if (widget.shadowRoot) {
          var shadowObserver = new MutationObserver(function () {
            setTimeout(updatePriceDisplay, 50);
          });

          shadowObserver.observe(widget.shadowRoot, {
            childList: true,
            subtree: true,
            attributes: true,
          });
        }
      }

      // Initialize when DOM is ready
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", observeWidget);
      } else {
        observeWidget();
      }

      return {
        updatePrice: updatePriceDisplay,
      };
    })();
    /**********************************************************************
      END –
      If the select for the product changes, update the price on the page
    ***********************************************************************/

    /**********************************************************************
     3. 
      Quantity Buttons handling
    ***********************************************************************/
    $(".quantity-box .pdp-minus").click(function (event) {
      var $el = $(this);
      pdpQuantityMinusHandler(event, $el);
    });

    $(".quantity-box .pdp-plus").click(function (event) {
      var $el = $(this);
      pdpQuantityPlusHandler(event, $el);
    });

    function updatePdpMinusButtonState() {
      // Iterate over each quantity box in case there are multiple on the page (e.g., for different products or variants)
      $(".quantity-box").each(function () {
        var $this = $(this),
          $input = $this.find(".quantity-input-wrap input"),
          quantity = parseInt($input.val(), 10),
          $minusBtn = $this.find(".pdp-minus");

        // If the quantity is 1 or less, disable the minus button
        if (quantity <= 1) {
          $minusBtn.addClass("disabled");
        } else {
          $minusBtn.removeClass("disabled");
        }
      });
    }
    updatePdpMinusButtonState();

    function pdpQuantityMinusHandler(event, element) {
      event.preventDefault();

      var input = $(element).siblings(".quantity-input-wrap").children("input"),
        count = $(input).val();

      if (count == 1) {
        // do nothing, can't have negative quantity
      } else if (count == 2) {
        count--;
        $(element).addClass("disabled");
        $(input).val(count);
      } else {
        count--;
        $(input).val(count);
      }
    }

    function pdpQuantityPlusHandler(event, element) {
      event.preventDefault();

      var input = $(element).siblings(".quantity-input-wrap").children("input"),
        minus = $(element).siblings(".minus"),
        count = $(input).val();

      $(minus).removeClass("disabled");
      count++;
      $(input).val(count);
    }

    /***  Now we create handlers for the cart quantity specifically ***/

    // Cart minus button
    $(document).on("click", ".cart-minus", function (event) {
      cartQuantityMinusHandler(event, $(this));
    });

    // Cart plus button
    $(document).on("click", ".cart-plus", function (event) {
      cartQuantityPlusHandler(event, $(this));
    });

    var debounceHelper; // Declare this outside the handlers to ensure it's accessible by both

    function cartQuantityMinusHandler(event, element) {
      event.preventDefault();

      var $cartItem = $(element).closest(".cart-item"),
        variantId = $cartItem.find(".cart-edit").data("id"), // Retrieve the variant ID
        input = $cartItem.find(".quantity-input"),
        count = parseInt(input.val(), 10);

      if (count == 1) {
        // do nothing, can't have negative quantity
      } else if (count == 2) {
        count--;
        $(element).addClass("disabled");
        $cartItem.addClass("loading");
        updateCartItemQuantity(variantId, count); // Update immediately for minus
      } else {
        $cartItem.addClass("loading");
        count--;
        updateCartItemQuantity(variantId, count); // Update immediately for minus
      }
    }

    function cartQuantityPlusHandler(event, element) {
      event.preventDefault();

      var $cartItem = $(element).closest(".cart-item"),
        variantId = $cartItem.find(".cart-edit").data("id"),
        input = $cartItem.find(".quantity-input"),
        minus = $cartItem.find(".minus"),
        count = parseInt(input.val(), 10);

      $(minus).removeClass("disabled");
      count++;
      input.val(count);

      // Clear any previously set timeout to ensure we're not making unnecessary calls
      clearTimeout(debounceHelper);

      // Set a new timeout
      debounceHelper = setTimeout(function () {
        $cartItem.addClass("loading");
        updateCartItemQuantity(variantId, count); // Update after a delay for plus
      }, 400);
    }

    function updateMinusButtonStates() {
      $(".cart-item").each(function () {
        var $this = $(this),
          quantity = parseInt($this.find(".quantity-input").val(), 10),
          $minusBtn = $this.find(".cart-minus");

        if (quantity <= 1) {
          $minusBtn.addClass("disabled");
        } else {
          $minusBtn.removeClass("disabled");
        }
      });
    }
    updateMinusButtonStates();

    /**********************************************************************
      END –
      Quantity Buttons handling
    ***********************************************************************/

    /**********************************************************************
     4. 
      Updating the cart state based on user using the .cart-minus and .cart-plus quantity box
    ***********************************************************************/
    function updateCartItemQuantity(lineItemKey, quantity) {
      var $cartItem = $('div[data-id="' + lineItemKey + '"]').closest(".cart-item");

      $.ajax({
        url: "/cart/change.js",
        type: "POST",
        dataType: "json",
        data: {
          id: lineItemKey,
          quantity: quantity,
        },
        success: function (cart) {
          //console.log('Cart updated successfully.', cart);
          CartPopup.update(function () {
            updateMinusButtonStates();
          });
        },
        error: function (xhr) {
          var errorMessage =
            xhr.responseJSON && xhr.responseJSON.message ? xhr.responseJSON.message : "An error occurred. Please try again.";
          console.error(errorMessage);

          CartPopup.update(function () {
            // Store the error message in a way that it can be globally accessible. Here it's done via data attribute.
            $(document).data("cart-update-error", errorMessage);

            // Trigger a custom event indicating that an error message is ready to be shown.
            // The errorToShow event should then be handled where you listen for this event.
            $(document).trigger("errorToShow");
          });
        },

        complete: function () {
          // I think we don't need this?
          //$cartItem.removeClass('loading');
        },
      });
    }
    /**********************************************************************
      END –
      Updating the cart state based on user using the .cart-minus and .cart-plus quantity box
    ***********************************************************************/

    /**********************************************************************
     5. 
      Update the shipping message and shipping 'load bar'
    ***********************************************************************/
    var cartTotal = parseFloat($(".cart-load-bar").data("pageload-total"));
    updateShippingProgress(cartTotal);
    function updateShippingProgress(cartTotal) {
      var $loadBarContainer = $(".cart-load-bar");
      var shippingThreshold = parseInt($loadBarContainer.data("shipping-threshold"), 10);
      var percentageOfThreshold = Math.min((cartTotal / shippingThreshold) * 100, 100);

      $(".load-bar").css("width", percentageOfThreshold + "%");

      if (cartTotal >= shippingThreshold) {
        $(".cart-message").text("Your order qualifies for free shipping!");
      } else {
        var amountRemaining = shippingThreshold - cartTotal;
        $(".cart-message").text("You are $" + amountRemaining.toFixed(2) + " away from getting free shipping.");
      }
    }

    /**********************************************************************
      END –
      Update the shipping message and shipping 'load bar'
    ***********************************************************************/

    /**********************************************************************
     6. 
      Adding to the AJAX Cart from product pages
        – Will probably need to be refactored a bit if we need to put 
          add to cart on none product pages
    ***********************************************************************/
    var AjaxAddToCart = (function () {
      var $ATC = $(".atc-btn");

      if (!$ATC.length) {
        return;
      }

      $(document).on("click", ".atc-btn", function (e) {
        e.preventDefault();
        var $form = $(e.currentTarget.form);
        $form.addClass("loading");
        var formData = $form.serialize();

        //console.log(formData);

        $.ajax({
          url: "/cart/add.js",
          type: "POST",
          data: formData,
          dataType: "json",
          success: function (cartItem) {
            //console.log(cartItem);

            // Ensure the cart is updated and opened after adding an item
            CartPopup.update(function () {
              CartPopup.open();
              $form.removeClass("loading");
            });
          },
          error: function (xhr) {
            var responseText = JSON.parse(xhr.responseText);
            var detailedErrorMessage = "";

            if (xhr.status === 422 && responseText.description.includes("You can't add more")) {
              detailedErrorMessage =
                "You attempted to add more of this item than we have in stock, we added as many as we possibly can to your cart.";
              updateCartItems(); // Trigger cart update
            } else if (responseText.description.includes("are in your cart")) {
              detailedErrorMessage =
                "The remaining inventory we have available of this product option is already in your cart. We can't add more!";
            } else {
              detailedErrorMessage = "Something went wrong trying to add to cart. Refresh your page and try again.";
            }

            displayErrorMessage(detailedErrorMessage);
            $form.removeClass("loading");
            openCart();
          },
        });
      });

      function displayErrorMessage(message) {
        $(".error-display-area").html(`<p class='error-message large'>${message}</p>`);
        setTimeout(function () {
          $(".error-message").remove();
        }, 10000); // Automatically remove the error message after 5 seconds for a cleaner UI
      }
    })();
    /**********************************************************************
      END –
      Adding to the AJAX Cart from product pages
    ***********************************************************************/

    /**********************************************************************
     7. 
      Removing an item from the AJAX Cart
    ***********************************************************************/
    var AjaxRemoveFromCart = (function () {
      $(document).on("click", ".remove-from-cart", function (e) {
        e.preventDefault();
        e.stopPropagation();

        var productId = $(this).attr("data-variant");
        var cartData = { updates: { [productId]: 0 } };

        $(e.currentTarget).parent().addClass("loading");

        $.ajax({
          type: "POST",
          url: "/cart/update.js",
          dataType: "json",
          data: cartData,
          complete: function (jqXHR, response) {
            if (jqXHR.status == 200) {
              //updated cart successfully
              CartPopup.update(function () {
                CartPopup.open();
              });
            }
          },
        });
      });
    })();
    /**********************************************************************
      END –
      Removing an item from the AJAX Cart
    ***********************************************************************/

    /**********************************************************************
     8. 
      Updates the AJAX cart
        – call this function when you need to re-render what's inside the
          cart via an AJAX call, remove/add/change/etc
    ***********************************************************************/
    var CartPopup = (function () {
      var $cart = $("#cart-pop");

      function updateCart(callback) {
        $.getJSON("/cart.js", function (data) {
          //console.log("inside of CartPopup.updateCart");
          //console.log(data);

          var subtotal = data.total_price;
          var count = data.item_count;
          var html = "";

          // Track both Mayday and Everyday products in cart
          var maydayInCart = false;
          var everydayInCart = false;

          // Update all instances of .cart-count-number with the new item count
          $(".cart-count-number").text(count);

          // Update shipping progress based on new cart total
          updateShippingProgress(subtotal / 100);

          if (count == 0) {
            $("#cart-popper").removeClass("itemsincart");
            html += `<h3 class="h4">Your cart is empty!</h4>`;
            $("#cartpop-checkout").addClass("nocheckout");
          } else {
            $("#cart-popper").addClass("itemsincart");
            $("#cartpop-checkout").removeClass("nocheckout");

            $.each(data.items, function (index, item) {
              var imageUrl = item.image ? item.image.split(".") : [];
              var img_ext = imageUrl[imageUrl.length - 1];
              if (img_ext) {
                var imageUrl = item.image.replace("." + img_ext, "_600x600." + img_ext);
              }

              // Check for subscription/selling plan info
              var subscriptionInfo = "";
              if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
                subscriptionInfo = `<span class="item__subscription-info">${item.selling_plan_allocation.selling_plan.name}</span>`;
              }

              html += `<div class="cart-item">
                <div class="cart-item__img">
                  <a href="/products/${item.handle}?variant=${item.id}">
                    <img class="ls-is-cached ed" src="${imageUrl}" alt="${item.product_title}" src="${imageUrl}">
                  </a>
                </div>
                <div class="cart-item__main">
                  <a href="/products/${item.handle}?variant=${item.id}" class="cart-summary cart-type">
                    <span class="item__title lead">${item.product_title}</span>
                    ${subscriptionInfo}
                    <span class="item__price normal">${Shopify.formatMoney(item.final_price)}</span>
                  </a>
                  <div class="cart-edit" data-id="${item.id}">
                    <div class="quantity-box quantity-box-cart">
                      <button class="minus quantity-btn cart-minus">
                        <span class="visually-hidden">Decrease quantity</span>
                        <span class="icon"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 100 100"><g><rect x="4" y="46" width="90" height="8"></rect></g></svg></span>
                      </button>
                      <div class="quantity-input-wrap">
                        <label class="visually-hidden" for="quantity-input-${item.id}-cart">Select how many you want</label>
                        <input class="quantity-input" id="quantity-input-${
                          item.id
                        }-cart" type="number" min="1" name="quantity" value="${item.quantity}" autocomplete="off">
                      </div>
                      <button class="plus quantity-btn cart-plus">
                        <span class="visually-hidden">Increase quantity</span>
                        <span class="icon"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 100 100"><g><polygon points="95 46 54 46 54 5 46 5 46 46 5 46 5 54 46 54 46 95 54 95 54 54 95 54 95 46"></polygon></g></svg></span>
                      </button>
                    </div>
                    <button class="remove-from-cart normal" data-variant="${item.id}">Remove</button>
                  </div>
                </div>
              </div>`;

              // Check for Mayday and Everyday product titles
              if (item.product_title.includes("Mayday")) {
                maydayInCart = true;
              }
              if (item.product_title.includes("Everyday")) {
                everydayInCart = true;
              }
            });
          }

          $cart.find(".cart-items").html(html);
          $cart.find("#cart-total-price").text(Shopify.formatMoney(subtotal));

          // Update shipping progress based on new cart total
          updateShippingProgress(subtotal / 100);

          // Set the shipping message based on the presence of Mayday and Everyday products
          if (maydayInCart && everydayInCart) {
            // Both products are in cart - expedited shipping unlocked
            $(".mayday-message").text("You've unlocked free expedited shipping with your purchase of both Mayday and Everyday!");
          } else if (maydayInCart) {
            // Only Mayday is in cart - prompt to add Everyday
            $(".mayday-message").text("Add Everyday to your order to unlock free expedited shipping.");
          } else if (everydayInCart) {
            // Only Everyday is in cart - prompt to add Mayday
            $(".mayday-message").text("Add Mayday to your order to unlock free expedited shipping.");
          } else {
            // Neither product is in cart - prompt to add either
            $(".mayday-message").text("Add both Mayday and Everyday to your order to unlock free expedited shipping.");
          }

          if (typeof callback === "function") callback();
        });
      }

      return {
        update: updateCart,
        open: function () {
          openCart();
        },
      };
    })();
    /**********************************************************************
      END –
      Updates the AJAX cart
    ***********************************************************************/

    /**********************************************************************
     9. 
      Create a custom event for handling error messages in the cart
    ***********************************************************************/
    function clearErrorDisplayArea() {
      $(".error-display-area").html("");
    }

    // Clear the error message area on various interactions
    $(".cart-minus, .cart-plus, .atc-btn, .pdp-minus, .pdp-plus, .remove-from-cart").on("click", function () {
      clearErrorDisplayArea();
    });

    $(document).on("errorToShow", function () {
      var errorMessage = $(document).data("cart-update-error"); // Retrieve the stored error message

      // Append the error message to a designated error display area in the cart
      $(".error-display-area").append("<p class='error-message large'>" + errorMessage + "</p>");

      // Clear the error message from the document's data attribute after displaying it
      $(this).removeData("cart-update-error");

      // Automatically clear the message from the cart after a delay (5 seconds here)
      setTimeout(function () {
        $(".error-message").remove();
      }, 10000);
    });
    /**********************************************************************
     END –
      Custom event for handling error messages in the cart
    ***********************************************************************/

    /**********************************************************************
     10. 
      The Shopify.formatMoney method extracted from option_selection.js for stand-alone purposes.
      Money format handler
    ***********************************************************************/
    var Shopify = Shopify || {};
    Shopify.money_format = "${{amount}}";
    Shopify.formatMoney = function (cents, format) {
      if (typeof cents == "string") {
        cents = cents.replace(".", "");
      }
      var value = "";
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || this.money_format;

      function defaultOption(opt, def) {
        return typeof opt == "undefined" ? def : opt;
      }

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ",");
        decimal = defaultOption(decimal, ".");

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split("."),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
          cents = parts[1] ? decimal + parts[1] : "";

        return dollars + cents;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
      }
      return formatString.replace(placeholderRegex, value);
    };
    /**********************************************************************
     END –
      Money format handler
    ***********************************************************************/
  }); // end .ready()
})(jQuery);
